import { styled } from '@mui/system';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Tab from '@mui/material/Tab';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

export const OverviewContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(),
  paddingTop: theme.spacing(3),
  height: 'calc(100% - 64px)',
  textAlign: 'left',
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3),
    paddingBottom: 0
  },
  '& .leftSidebar > div.events': {
    [theme.breakpoints.up('md')]: {
      height: 'calc(100% - 48px);',
      '&::-webkit-scrollbar-track': {
        WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
        borderRadius: 10,
        backgroundColor: '#F5F5F5'
      },
      '&::-webkit-scrollbar': {
        width: 8,
        backgroundColor: '#F5F5F5'
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: 10,
        WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
        backgroundColor: '#a0a0a0'
      }
    }
  },
  '@media screen and (max-height: 500px)': {
    height: 'auto'
  }
}));

export const MeasurementsWrapper = styled(Grid)(({ theme }) => ({
  height: '100%',
  position: 'relative',
  [theme.breakpoints.up('md')]: {
    maxWidth: '72%',
    flexBasis: '72%'
  },
  '@media screen and (max-height: 500px)': {
    paddingBottom: `${theme.spacing(3)} !important`
  }
}));

export const DeviceInfoGridItem = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('xs')]: {
    marginTop: 0
  },
  [theme.breakpoints.up('sm')]: {
    marginTop: 0
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: -8
  }
}));

export const DeviceNameContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    marginTop: -12
  },
  [theme.breakpoints.down('sm')]: {
    '& h5': {
      fontSize: '1.8rem',
      paddingLeft: '44px'
    }
  }
}));

export const DeviceName = styled(Typography, {
  shouldForwardProp: prop => prop !== 'off'
})(({ off }) => ({
  margin: 0,
  verticalAlign: 'middle',
  ...(off && {
    color: '#667'
  }),
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}));

export const InfoContainer = styled('div')(({ theme }) => ({
  marginBottom: 0,
  [theme.breakpoints.up('md')]: {
    marginBottom: -22
  },
  display: 'flex',
  '& span, & svg': {
    verticalAlign: 'text-bottom',
    whiteSpace: 'nowrap'
  }
}));

export const Info = styled('div')(({ theme }) => ({
  marginRight: theme.spacing(),
  marginBottom: theme.spacing()
}));

export const DateRangeGridItem = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    marginLeft: '44px',
    justifyContent: 'flex-start'
  },
  '&.MuiGrid-item': {
    [theme.breakpoints.up('sm')]: {
      paddingTop: 8,
      paddingBottom: 24
    }
  },
  display: 'flex',
  justifyContent: 'flex-end',
  '& p.Mui-error': {
    position: 'absolute',
    margin: 0,
    marginTop: 4,
    padding: '8px 14px',
    top: 60,
    background: '#FF4635',
    color: '#FFF',
    width: '100%',
    zIndex: 10,
    boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    borderRadius: 4
  }
}));

export const TabContainer = styled('div')(() => ({
  position: 'relative',
  zIndex: 1
}));

export const TabBar = styled(AppBar)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  backgroundColor: '#FFF',
  borderTopLeftRadius: theme.spacing(),
  borderTopRightRadius: theme.spacing()
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  minWidth: 72,
  display: 'flex',
  flexDirection: 'row',
  // Target the text spans inside the tab label (after SVG icon)
  '& svg + span': {
    marginLeft: theme.spacing(),
    height: '13px'
  }
}));

export const ContentContainer = styled(Grid)(() => ({
  height: 'calc(100% - 86px)',
  '@media (max-width: 900px) and (orientation: landscape)': {
    height: 'auto !important'
  }
}));

export const MobileHeader = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      padding: '0 !important'
    }
  }
}));

export const DialogAppBar = styled(AppBar)(() => ({
  position: 'fixed',
  backgroundColor: 'black',
  color: 'white'
}));

export const CloseIcon = styled(IconButton)(() => ({
  position: 'absolute',
  right: 0,
  color: '#FFF'
}));

export const CardWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing()
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  width: '90%',
  height: '150px',
  margin: '-90px auto 0 auto',
  borderRadius: '20px',
  cursor: 'pointer',
  boxShadow: '0px 0px 25px -12px rgba(0, 0, 0, 0.658)',
  '&:first-of-type': {
    marginTop: theme.spacing(2)
  }
}));

export const CardHeader = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between'
}));

export const CardHeaderText = styled(Typography)(() => ({
  fontSize: '1.1rem',
  fontWeight: 500,
  padding: '0 5px'
}));

export const CardIdentifiers = styled('p')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: 0,
  fontSize: '1.1rem',
  fontWeight: 500,
  margin: 0,
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  lineHeight: '1.5',
  letterSpacing: '0.00938em',
  '& svg': {
    marginRight: theme.spacing(1.5),
    paddingBottom: '2px'
  }
}));

export const NoLocations = styled('div')(() => ({
  marginTop: 50,
  textAlign: 'center',
  '& h4': {
    color: '#667'
  }
}));

export const StyledDivider = styled(Divider)(() => ({
  marginTop: -1
}));
